<template>
  <div class="l-d-logo">
    <img class="logo" src="@/assets/img/global/header_logo.svg" />
  </div>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Logo',
});
</script>
<style lang="scss" scoped>
.logo {
  width: 168px;
}

</style>
